export const showAll = data => {
  const link = {
    categoryId: '',
    locationIds: [],
    productType: ['all'],
    query: '',
    lotType: '',
    tagIds: '',
    searchInDescription: false,
  };

  let query = '';

  for (let key in data) {
    switch (key) {
      case 'lotType':
        if (data[key]) {
          link.lotType = data[key];
        }
        break;
      case 'category':
        if (data[key] !== null) {
          link.categoryId = data[key].id;
        }
        break;
      case 'locations':
        if (data[key].length > 0) {
          data[key].forEach(el => {
            link.locationIds.push(el.id);
          });
        }
        break;
      case 'productType':
        if (data[key]) {
          link.productType[0] = data[key].toLowerCase();
        }
        break;
      case 'searchInDescription':
        if (data[key]) {
          link.searchInDescription = data[key];
        }
        break;
      case 'lotState':
        if (data[key]) {
          link.productType[1] = data[key];
        }
        break;
      case 'query':
        if (data[key]) {
          link.query = data[key];
        }
        break;
      case 'tags':
        if (data[key].length > 0) {
          link.tagIds = data[key][0].id;
        }
        break;
      default:
        break;
    }
  }

  for (let queryKey in link) {
    switch (typeof link[queryKey]) {
      case 'object':
        if (link[queryKey].length > 0) {
          query += queryKey + '=' + link[queryKey] + '&';
        }
        break;
      default:
        if (link[queryKey]) {
          query += queryKey + '=' + link[queryKey] + '&';
        }
        break;
    }
  }

  window.location.href = `/?${query.slice(0, -1)}`;
};
